export default __webpack_public_path__ + "static/media/email.4a1e7174.jpg";